var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _rect2, _rect3, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 561,
    height: 60,
    viewBox: "0 0 561 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M365.18 56L354.616 40.5474L349.994 45.4207V56H343.245V20.8827H349.994V36.6537L364.886 20.8827H373.249L359.433 35.4537L373.543 56H365.18Z",
    fill: "#18191B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M305.733 38.4414C305.66 27.6662 311.945 20.295 322.508 20.3929C331.483 20.295 336.814 25.7315 337.229 32.417H330.48C329.722 28.5967 326.983 26.4172 322.753 26.4172H322.264C316.517 26.3438 312.434 31.0456 312.507 38.4414C312.507 45.8616 316.468 50.49 322.264 50.49H322.753C327.032 50.49 329.722 48.3839 330.48 44.4657H337.229C336.789 51.4206 331.532 56.5633 322.508 56.4898C311.945 56.5878 305.66 49.2166 305.733 38.4414Z",
    fill: "#18191B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M297.15 56L293.996 47.7227H279.275L276.12 56H269.004L282.869 20.8827H290.792L304.315 56H297.15ZM281.549 41.6984H291.697L286.611 28.3763L281.549 41.6984Z",
    fill: "#18191B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M243.035 56V20.8827H258.807C265.63 20.8827 270.08 24.9724 270.08 31.9273C270.08 38.8822 265.63 43.0208 258.807 43.0208H249.784V56H243.035ZM249.784 36.9965H258.049C261.472 36.9965 263.306 35.0374 263.306 31.9273C263.306 28.8171 261.472 26.907 258.049 26.907H249.784V36.9965Z",
    fill: "#18191B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M190.949 38.4414C190.851 27.3723 197.991 20.2705 207.968 20.3929C217.945 20.2705 225.135 27.3723 225.012 38.4414C225.135 49.5104 217.945 56.6122 207.968 56.4898C197.991 56.6122 190.851 49.5104 190.949 38.4414ZM207.724 50.49H208.237C214.473 50.49 218.239 45.935 218.239 38.4414C218.239 30.9232 214.473 26.4172 208.237 26.4172H207.724C201.488 26.4172 197.722 30.9232 197.722 38.4414C197.722 45.935 201.488 50.49 207.724 50.49Z",
    fill: "#18191B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M158.67 56V20.8827H174.956C180.825 20.8092 185.838 25.0213 185.715 30.4334C185.715 34.9149 183.759 37.8046 179.749 39.2985C183.392 39.2985 185.202 40.9637 185.202 44.2698V56H178.453V45.9595C178.453 43.4371 177.719 42.7024 175.2 42.7024H165.419V56H158.67ZM165.419 36.8006H172.951C176.888 36.8006 178.942 35.0374 178.942 31.7314C178.942 28.4988 176.961 26.907 172.951 26.907H165.419V36.8006Z",
    fill: "#18191B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M126 56V20.8827H141.773C148.595 20.8827 153.046 24.9724 153.046 31.9273C153.046 38.8822 148.595 43.0208 141.773 43.0208H132.749V56H126ZM132.749 36.9965H141.014C144.438 36.9965 146.272 35.0374 146.272 31.9273C146.272 28.8171 144.438 26.907 141.014 26.907H132.749V36.9965Z",
    fill: "#18191B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 40,
    height: 40,
    rx: 2,
    fill: "url(#paint0_linear_14213_42748)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    width: 60,
    height: 60,
    rx: 2,
    fill: "url(#paint1_linear_14213_42748)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    width: 60,
    height: 60,
    rx: 2,
    fill: "#D5E6FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3333 0C31.4924 0 30 1.49239 30 3.33333V56.6667C30 57.6408 30.4178 58.5173 31.084 59.1267L60 35.8333V0H33.3333Z",
    fill: "url(#paint2_linear_14213_42748)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3333 0C31.4924 0 30 1.49239 30 3.33333V56.6667C30 57.6408 30.4178 58.5173 31.084 59.1267L60 35.8333V0H33.3333Z",
    fill: "url(#paint3_linear_14213_42748)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M90 56.6667V3.33333C90 1.49238 88.5076 0 86.6667 0H60V35.8333L88.916 59.1267C89.5822 58.5173 90 57.6408 90 56.6667Z",
    fill: "url(#paint4_linear_14213_42748)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M90 56.6667V3.33333C90 1.49238 88.5076 0 86.6667 0H60V35.8333L88.916 59.1267C89.5822 58.5173 90 57.6408 90 56.6667Z",
    fill: "url(#paint5_linear_14213_42748)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3333 60H86.6666C87.5335 60 88.323 59.6691 88.9159 59.1268L59.9999 35.8334L31.084 59.1268C31.6769 59.6691 32.4664 60 33.3333 60Z",
    fill: "url(#paint6_linear_14213_42748)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3333 60H86.6666C87.5335 60 88.323 59.6691 88.9159 59.1268L59.9999 35.8334L31.084 59.1268C31.6769 59.6691 32.4664 60 33.3333 60Z",
    fill: "url(#paint7_linear_14213_42748)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3333 60H86.6666C87.5335 60 88.323 59.6691 88.9159 59.1268L59.9999 35.8334L31.084 59.1268C31.6769 59.6691 32.4664 60 33.3333 60Z",
    fill: "url(#paint8_linear_14213_42748)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M31.084 59.1267L40 51.9444V23.3333C40 21.4924 38.5076 20 36.6667 20H30V56.6667C30 57.6408 30.4178 58.5173 31.084 59.1267Z",
    fill: "url(#paint9_linear_14213_42748)",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14213_42748",
    x1: 20,
    y1: 20,
    x2: 20,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14213_42748",
    x1: 60,
    y1: 0,
    x2: 60,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14213_42748",
    x1: 45,
    y1: 0,
    x2: 45,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_14213_42748",
    x1: 45,
    y1: 0,
    x2: 45,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFC1D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5D4E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_14213_42748",
    x1: 75,
    y1: 0,
    x2: 75,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_14213_42748",
    x1: 75,
    y1: 0,
    x2: 75,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2E0F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_14213_42748",
    x1: 60,
    y1: 39.1667,
    x2: 60,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_14213_42748",
    x1: 60,
    y1: 39.1667,
    x2: 60,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFC1D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5D4E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_14213_42748",
    x1: 60,
    y1: 39.1667,
    x2: 60,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A3139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#565E67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_14213_42748",
    x1: 60,
    y1: 20,
    x2: 60,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF500"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f533f975ca1bd5dbfc7d3069f12789fa.svg";
export { ForwardRef as ReactComponent };